import React from "react";
import { motion } from "framer-motion";

const cards = [
  { gradient: "gradient-blue",   number: "2050",  label: "Vehicle Count",     icon: "fa-car" },
  { gradient: "gradient-pink",   number: "3250",  label: "Consumption Units", icon: "fa-bolt" },
  { gradient: "gradient-green",  number: "87.5%", label: "Vendors",           icon: "fa-handshake-o" },
  { gradient: "gradient-orange", number: "2550",  label: "Total Revenue",     icon: "fa-inr" },
];

const containerVariants = {
  hidden: {},
  show  : { transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 22, scale: 0.96 },
  show  : {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.38, ease: [0.4, 0, 0.2, 1] },
  },
};

const DashBoardCard: React.FC = () => {
  return (
    <div className="container">
      <motion.div
        className="columns is-multiline"
        variants={containerVariants}
        initial="hidden"
        animate="show"
      >
        {cards.map((card, i) => (
          <div
            key={i}
            className="column is-12-mobile is-6-tablet is-one-quarter-desktop"
          >
            <motion.div
              className={`stat-card ${card.gradient} box has-text-centered`}
              variants={cardVariants}
              whileHover={{
                y: -5,
                scale: 1.01,
                transition: { duration: 0.2, ease: "easeOut" },
              }}
              whileTap={{
                scale: 0.97,
                transition: { duration: 0.08 },
              }}
            >
              <motion.div
                className="stat-number"
                initial={{ opacity: 0, scale: 0.7 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.15 + i * 0.1, duration: 0.4, ease: "backOut" }}
              >
                {card.number}
              </motion.div>
              <div className="stat-label">{card.label}</div>
              <span className="icon is-large is-size-4">
                <i className={`fa ${card.icon}`}></i>
              </span>
            </motion.div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default DashBoardCard;
